import AppRoutes from "./Routes.tsx";

function App() {
  return (
      <AppRoutes />
  )
}

export default App
